<template>
  <Carousel :slide_count="slide_count"
            :current_slide="current_slide"
            :slide-interval="slideInterval"
            :theme="theme"
            @next="next"
  >
    <CarouselSlide v-for="(slide, index) in slides"
                   :key="slide.id"
                   :index="index"
                   :current_slide="current_slide"
    >
      <div class="slide-wrapper">
        <p class="slide-title" v-html="slide.title"/>
        <p class="slide-body" v-html="slide.body"/>
      </div>
    </CarouselSlide>
  </Carousel>
</template>

<script>
import Carousel from './Carousel/Carousel.vue'
import CarouselSlide from './Carousel/CarouselSlide.vue'

export default {
  props:{
    slides:{
      type: Object,
      default: [{id: 0, body: "questo è l'avviso di defaul che verrà sempre visualizzato", title: "<b>I.T.T.S. DIVINI</b>"}]
    },
    slideInterval: {
      type: Number,
      default: 10000
    },
    theme: {
      type: Object,
      default: {
        background: 'lightcyan',
        dotspace: 'lightblue',
        dots: 'blue',
        text: 'black'
      }
    }
  },
  data(){
    return{
      current_slide: 0
    }
  },
  computed:{
    slide_count(){
      return this.slides.length
    }
  },
  methods:{
    next(){
      this.current_slide = (this.current_slide + 1) % this.slide_count
    }
  },
  name: "KioskCarousel",
  components: {
    Carousel, CarouselSlide
  }
}
</script>

<style scoped>
.slide-wrapper{
  text-align: center;
}
.slide-title{
  font-size: 5vh;
}
.slide-body{
  font-size: 3vh;
}
p{
  margin: 10px 160px 0 160px;
}
</style>